import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// Styles are loaded in cascade order: tokens, then the reset, then components.
// v1 additionally loaded all of Bootstrap, react-toastify's CSS and Quill's
// CSS globally and unconditionally here.
import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';
import './styles/print.css';

import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    {/*
      The two v7 future flags are opted into now rather than on upgrade day.
      Both change behaviour, and both are cheaper to absorb here — while the
      router is doing very little — than as part of a version bump that also
      changes twenty other things:

        v7_startTransition    navigation state updates are wrapped in
                              React.startTransition
        v7_relativeSplatPath  relative paths inside a splat route resolve from
                              the matched path rather than the splat itself

      Turning them on also silences the two console warnings that were burying
      real errors underneath them.
    */}
    <BrowserRouter
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
    >
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
